<template>
  <el-card shadow="never" class="l-main-card">
    <div class="l-table-toolbar">
      <l-auth-button type="primary" auth="consumable_add_btn" @click="add_visible = true"> 新增耗材 </l-auth-button>
      <!-- <l-auth-button type="success" auth="hall_import_btn" @click="showImport" style="margin-left:20px"> 导入 </l-auth-button> -->
      <div class="l-simple-search-container">
        <el-input placeholder="搜索名称/型号/备注/编号" v-model="search_data.keywords" class="input-with-select">
          <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
        </el-input>
      </div>
    </div>
    <l-table :data="data" v-loading="loading" row-key="id">
      <el-table-column fixed prop="index" label="序号" width="100"> </el-table-column>
      <el-table-column prop="consumable_no" label="耗材编码" min-width="140" show-overflow-tooltip fixed>
        <template v-slot="{ row }">
          <l-auth-text-button type="primary" auth="consumable_info" @click="showInfo(row.id)" :no-auth-visible="true">{{ row.consumable_no }}</l-auth-text-button>
        </template>
      </el-table-column>
      <el-table-column prop="name" fixed label="耗材名称" min-width="200" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="brand" label="品牌" min-width="150" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="spec" label="规格型号" min-width="200" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="count" label="库存" min-width="100" show-overflow-tooltip> </el-table-column>
      <el-table-column label="图片" min-width="300" show-overflow-tooltip>
        <template v-slot="{ row }">
          <my-img-component :images="row.imgs" :width="30" :height="30"></my-img-component>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="200" show-overflow-tooltip> </el-table-column>

      <el-table-column prop="user_name" label="创建人" width="120"> </el-table-column>
      <el-table-column prop="create_time" label="创建时间" width="180"> </el-table-column>
      <el-table-column prop="update_time" label="修改时间" width="180"> </el-table-column>

      <el-table-column fixed="right" label="操作" width="220" align="center">
        <template slot-scope="{ row }">
          <l-auth-text-button type="primary" auth="consumable_add_count_btn" @click="showAddCount(row.id)"><i class="el-icon-plus"></i>入库</l-auth-text-button>
          <span class="l-action-separator">|</span>
          <l-auth-text-button type="primary" auth="consumable_edit_btn" @click="showEdit(row.id)"><i class="el-icon-edit"></i>编辑</l-auth-text-button>
          <span class="l-action-separator">|</span>
          <l-auth-text-button type="danger" auth="consumable_del_btn" @click="del(row.id)"><i class="el-icon-delete"></i>删除</l-auth-text-button>
        </template>
      </el-table-column>
    </l-table>

    <!--分页-->
    <l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size" :current-page.sync="page"></l-page>

    <!--添加-->
    <l-dialog :visible.sync="add_visible" title="新增耗材" width="1000px">
      <l-consumable-edit @on-success="onAddSucess" :visible.sync="add_visible" />
    </l-dialog>

    <!--编辑-->
    <l-dialog :visible.sync="edit_visible" title="编辑耗材" width="1000px">
      <l-consumable-edit @on-success="onEditSuccess" :visible.sync="edit_visible" :id="edit_id" />
    </l-dialog>

    <!--入库-->
    <l-dialog :visible.sync="add_count_visible" title="入库" width="800px">
      <l-consumable-add-count @on-success="onAddCountSuccess" :visible.sync="add_count_visible" :id="add_count_id" />
    </l-dialog>

    <!--详情-->
    <l-dialog :visible.sync="info_visible" title="详情" width="1200px">
      <l-consumable-info :id="info_id" :visible.sync="info_visible" />
    </l-dialog>

  </el-card>
</template>

<script>
import Vue from "vue";
import Edit from "./Edit";
import MyImg from "@/components/img/MyImg";
import AddCount from "./AddCount";
import Info from "./Info";
export default {
  components: {
    [Edit.name]: Edit,
    [MyImg.name]: MyImg,
    [AddCount.name]: AddCount,
    [Info.name]: Info,
  },
  data() {
    return {
      data: [],
      count: 0,
      page: 1,
      page_size: Vue.$_config.page.page_size,
      loading: false,

      add_visible: false, //是否显示添加

      edit_visible: false, //是否显示编辑
      edit_id: 0,

      add_count_visible: false, //是否显示入库
      add_count_id: 0,

      info_visible: false,
      info_id: 0,

      import_visible: false, //是否显示营业厅导入

      //搜索
      search_visible: false,
      search_data: {
        keywords: "",
      },
      rel_search_data: {},
      show_more_search: false,
    };
  },

  mounted() {
    this.getList();
  },

  methods: {
    //获取数据
    getList() {
      this.loading = true;
      this.$_invoke("consumable_getList", {
        page: this.page,
        page_size: this.page_size,
        ...this.rel_search_data,
      })
        .then((ret) => {
          this.data = ret.data;
          this.count = ret.count;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //点击搜索按钮
    onSearch() {
      this.page = 1;
      this.rel_search_data = this.search_data;
      this.getList();
    },

    //点击重置搜索框
    onReset() {
      this.$refs.search_form.resetFields();
      this.rel_search_data = {};
    },

    //添加成功回调
    onAddSucess() {
      this.add_visible = false;
      this.getList();
    },

    //显示修改界面
    showEdit(id) {
      this.edit_id = id;
      this.$nextTick(() => {
        this.edit_visible = true;
      });
    },

    //编辑成功回调
    onEditSuccess() {
      this.edit_visible = false;
      this.getList();
    },

    //显示修改界面
    showAddCount(id) {
      this.add_count_id = id;
      this.$nextTick(() => {
        this.add_count_visible = true;
      });
    },

    //编辑成功回调
    onAddCountSuccess() {
      this.add_count_visible = false;
      this.getList();
    },

    //显示详情页面
    showInfo(id) {
      this.info_id = id;
      this.$nextTick(() => {
        this.info_visible = true;
      });
    },

    //删除
    del(id) {
      this.$confirm("确定删除该条记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$_invoke(`consumable_delete`, { id }).then(() => {
            this.$_msg.success("删除成功");
            this.getList();
          });
        })
        .catch(() => {});
    },
  },
};
</script>
